import { render, staticRenderFns } from "./image-create.vue?vue&type=template&id=682af402&"
import script from "./image-create.vue?vue&type=script&lang=js&"
export * from "./image-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('682af402', component.options)
    } else {
      api.reload('682af402', component.options)
    }
    module.hot.accept("./image-create.vue?vue&type=template&id=682af402&", function () {
      api.rerender('682af402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/views/material/image-create.vue"
export default component.exports